import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useFormik } from "formik";
import * as Yup from "yup";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SECTION_SPACING_IN_REM } from "config/layout_config";
import Error from "components/error/Error";

const Container = tw.div`relative`;
const Content = styled.div`
  padding-top: ${SECTION_SPACING_IN_REM}rem;
  ${tw.div`max-w-screen-xl mx-auto`}
`;

const FormContainer = styled.form`
  ${tw`p-10 sm:p-12 md:p-16 bg-primary-500 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,
  textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 text-gray-100 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`;

export default () => {
  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      message: "",
    },

    validationSchema: Yup.object({
      email: Yup.string().required("Required"),
      name: Yup.string().required("Required"),
      message: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });
  return (
    <Container id="contactUs">
      <Content>
        <FormContainer onSubmit={formik.handleSubmit}>
          <div tw="mx-auto max-w-4xl">
            <h2>Contact Us</h2>
            <TwoColumn>
              <Column>
                <InputContainer>
                  <Label>Your Name</Label>
                  <Input
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    type="text"
                    name="name"
                    placeholder="E.g. John Doe"
                  />
                  {formik.errors.name && formik.touched.name ? (
                    <Error redColor={false} errorName={formik.errors.name} />
                  ) : null}
                </InputContainer>
                <InputContainer>
                  <Label>Your Email Address</Label>
                  <Input
                    onChange={formik.handleChange}
                    type="email"
                    value={formik.values.email}
                    name="email"
                    placeholder="E.g. john@mail.com"
                  />
                  {formik.errors.email && formik.touched.email ? (
                    <Error redColor={false} errorName={formik.errors.email} />
                  ) : null}
                </InputContainer>
              </Column>
              <Column>
                <InputContainer tw="flex-1">
                  <Label>Your Message</Label>
                  <TextArea
                    onChange={formik.handleChange}
                    value={formik.values.message}
                    name="message"
                    placeholder="E.g. Details about your event"
                  />
                  {formik.errors.message && formik.touched.message ? (
                    <Error redColor={false} errorName={formik.errors.message} />
                  ) : null}
                </InputContainer>
              </Column>
            </TwoColumn>
            <SubmitButton type="submit">Submit</SubmitButton>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
